const isValidToken = () => {
  const expiresAt = Number(localStorage.getItem('MDM_ACCESS_TOKEN_EXPIRES_AT'));
  return !!(localStorage.getItem('MDM_ACCESS_TOKEN') && new Date().getTime() < expiresAt);
};

export default isValidToken;